import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Loader } from "semantic-ui-react";
import Navbarside from "../component/Navbarside";
import { roomcategory } from "../store/slices/roomcategory";
import { Link } from "react-router-dom";
import Footer from "./footer";
import Moment from "moment";
function RoomCategory() {
  const [expertises, setexpertise] = useState([]);
  const { loading } = useSelector((state) => state.auth);
  const dispatch = useDispatch();

  React.useEffect(() => {
    dispatch(roomcategory())
      .unwrap()
      .then((data) => {
        setexpertise(data.user.data);
      })
      .catch(({ message }) => {
        alert(message);
      });
  }, [dispatch]);

  return (
    <div>
      <Navbarside />

      <div className="container-fluid pb-5 response-cover">
        <div className="row">
          <div className="col-lg-2 col-md-4" />
          <div className="col-lg-10 col-md-8">
            <div className="container-fluid pt-5">
              <div className="row">
                <div className="col-12">
                  <div className="card">
                    <div className="card-header">
                      <div className="card-title-wrap bar-success">
                        <h4 className="card-title">
                          Room Categories &nbsp; &nbsp;
                          <Link
                            to="/AddRoomCategory"
                            className="btn btn-primary"
                          >
                            <i className="fa fa-plus"></i> Add
                          </Link>
                        </h4>
                      </div>
                    </div>
                    <div className="card-body collapse show">
                      <div className="card-block card-dashboard table-responsive">
                        <table className="table table-striped table-bordered zero-configuration">
                          <thead>
                            <tr>
                              <th>Category Name</th>
                              <th>Image</th>
                              <th>Added On</th>
                            </tr>
                          </thead>
                          {loading ? (
                            <Loader active inline />
                          ) : (
                            <>
                              <tbody>
                                {expertises.map((HotelVal, index) => (
                                  <tr key={index}>
                                    <td>{HotelVal.name}</td>
                                    <td>
                                      <img
                                        src={HotelVal.imageUrl}
                                        style={{
                                          width: "150px",
                                          height: "100px",
                                        }}
                                        alt=""
                                      />
                                    </td>

                                    <td>
                                      {Moment(HotelVal.created_at).format(
                                        "DD-MM-YYYY"
                                      )}
                                    </td>
                                    {/* <td>{HotelVal.updated_at}</td> */}
                                  </tr>
                                ))}
                              </tbody>
                            </>
                          )}
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container pt-5">
        <section id="configuration"></section>
      </div>

      <Footer />
    </div>
  );
}
export default RoomCategory;
